export enum ProgramTypeEnum {
    AllDescription = 'All',
    All = 0,
    FullProgramDescription = 'Full Program',
    FullProgram = 1,
    HRADescription = 'HRA',
    HRA = 2,
    FUHFUMDescription = 'FUHFUM',
    FUHFUM = 3,
    andNextDescription = 'andNext',
    andNext = 4
}